import {Box, Typography} from '@mui/material';
import lockIcon from '@icons/lock.svg';
import {IMAGE_TABLE_ALT, H5, FIELD, TEXT} from '@/utils/constants';
import {forgotPasswordModalStyles} from './ForgotPasswordStyle.styles';
import Input from '@/shared/components/Inputs/Input';
import Button from '@/shared/components/Button';
import {Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {emailSchema} from '@/utils/validation';

interface ForgotPasswordStep1Props {
	onCloseModal: () => void;
	handleSubmit: (values: any) => void;
}
const validationSchema = () => {
	return Yup.object().shape({
		email: emailSchema,
	});
};

const ForgotPasswordStep1 = ({onCloseModal, handleSubmit}: ForgotPasswordStep1Props) => {
	return (
		<Box sx={forgotPasswordModalStyles.content}>
			<Box sx={forgotPasswordModalStyles.iconWrap}>
				<img src={lockIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={forgotPasswordModalStyles.contentWrap}>
				<Typography variant={H5} sx={forgotPasswordModalStyles.title}>
					Forgot Your Password?
				</Typography>
				<Typography sx={forgotPasswordModalStyles.description}>
					Enter your email address and we’ll send you a link to reset it
				</Typography>
			</Box>
			<Box sx={forgotPasswordModalStyles.formWrap}>
				<Formik initialValues={{email: ''}} validationSchema={validationSchema()} onSubmit={handleSubmit}>
					{() => (
						<Form>
							<Box sx={forgotPasswordModalStyles.fieldWrap}>
								<Field
									id={FIELD.email}
									name={FIELD.email}
									placeholder="email@example.mail.com"
									label="Email"
									component={Input}
									type={TEXT}
								/>
							</Box>
							<Box sx={forgotPasswordModalStyles.textWrap}>
								<Typography sx={{whiteSpace: 'nowrap', color: 'var(--neutral-600)'}}>
									Remember your password?
								</Typography>
								<Button variant="text" size="small" title="Log in" onClick={onCloseModal} disableRipple />
							</Box>
							<Box sx={forgotPasswordModalStyles.btnWrap}>
								<Button
									variant="outline"
									sx={forgotPasswordModalStyles.btn}
									onClick={onCloseModal}
									title="Cancel"
									disableRipple
								/>
								<Button type="submit" sx={forgotPasswordModalStyles.btn} title="Reset Password" disableRipple />
							</Box>
						</Form>
					)}
				</Formik>
			</Box>
		</Box>
	);
};

export default ForgotPasswordStep1;
